import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { computed, PropType } from 'vue';
import { BuildableDialogItem } from '@/models/BuildableDialogItem';
import IconComponent from '@/components/icon/IconComponent.vue';
import Icon from '@/components/icon/Icon';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuildableDialogItemComponent',
  props: {
  dialogItem: {
    type: Object as PropType<BuildableDialogItem>,
    required: true
  },
  index: {
    type: Number,
    required: true
  },
  active: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props



const icon = computed(() => {
  if (props.active) {
    return Icon.PAUSE_DARK;
  }
  return Icon.PAUSE_LIGHT;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["dialog-item", { active: __props.active }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('selectDialogItem', __props.dialogItem, __props.index)))
  }, [
    _createTextVNode(_toDisplayString(__props.dialogItem.textValue) + " ", 1),
    (__props.dialogItem.textValue === ' ')
      ? (_openBlock(), _createBlock(IconComponent, {
          key: 0,
          icon: _unref(icon),
          class: "inline-block"
        }, null, 8, ["icon"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})